module.exports = __webpack_public_path__ + "assets/img/con5-bg.689892ce.jpg";